(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8196],{

/***/ 35106:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[slug]",
      function () {
        return __webpack_require__(6982);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79373);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const ErrorComponent = (props)=>{
    const { serverError  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        function randomNum() {
            "use strict";
            return Math.floor(Math.random() * 9) + 1;
        }
        let increaseTimer = 0;
        const time = 30, selector3 = document.querySelector(".thirdDigit"), selector2 = document.querySelector(".secondDigit"), selector1 = document.querySelector(".firstDigit");
        const loop3 = setInterval(function() {
            "use strict";
            if (increaseTimer > 40) {
                clearInterval(loop3);
                if (selector3) selector3.textContent = serverError ? "5" : "4";
            } else {
                if (selector3) selector3.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop2 = setInterval(function() {
            "use strict";
            if (increaseTimer > 80) {
                clearInterval(loop2);
                if (selector2) selector2.textContent = "0";
            } else {
                if (selector2) selector2.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop1 = setInterval(function() {
            "use strict";
            if (increaseTimer > 100) {
                clearInterval(loop1);
                if (selector1) selector1.textContent = serverError ? "0" : "4";
            } else {
                if (selector1) selector1.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "error-component",
        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-xs-12 text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().containerError404),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} thirdDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} secondDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} firstDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().msg),
                                    children: [
                                        "OH!",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().triangle)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "h1",
                            children: "OOPS, SORRY WE CAN'T FIND THAT PAGE!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Either something went wrong or the page doesn't exist anymore."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btndiv),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btnPrimary)}`,
                                    children: "Back to home"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorComponent);


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://staging.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 6982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ErrorComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46412);
/* harmony import */ var _components_MetaTagsComp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47046);
/* harmony import */ var _components_BlogDetailPage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96880);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59830);






const NewsAndPressDetail = (props)=>{
    if (!props.pageData || props.pageData.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ErrorComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
    }
    const { meta  } = props.pageData[0] || {};
    const slug = props.pageData[0].slug;
    const updatedMeta = {
        ...meta,
        canonicalUrl: `${"https://staging.studies-overseas.com"}/blogs/${slug}`,
        jotforms: meta?.jotforms?.length === 0 ? _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .commonJotformScript */ .Y4 : meta?.jotforms
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6C48F0");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            updatedMeta && props.pageData?.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MetaTagsComp__WEBPACK_IMPORTED_MODULE_3__/* .MetaTagsComp */ .r, {
                ...updatedMeta,
                isBlogPage: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogDetailPage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                ...props,
                category: "blogs"
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (NewsAndPressDetail);


/***/ }),

/***/ 79373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__5J6pK","clip":"Error_clip__SVATU","shadow":"Error_shadow__FSdAk","main":"Error_main__RrWpw","digit":"Error_digit__HcJVc","btndiv":"Error_btndiv__gV_0s","btnPrimary":"Error_btnPrimary__RVY52","msg":"Error_msg__ksdYX","triangle":"Error_triangle__qa4xL","containerError404":"Error_containerError404__DhF_F"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,3656,4010,7568,9774,2888,179], function() { return __webpack_exec__(35106); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);